export { InstitutionalServicesPage as default } from "@nvb/ui";
